import { useEffect } from 'react'
import { useMutation } from '@apollo/client'
import { TOUCH_ATTRIBUTION } from 'api/attribution/touch-attribution'
import { featureFlags } from 'app/app-feature-flags'
import { captureAttribution } from './attribution'
import { readStoredAttribution, storeAttribution } from './attribution-storage'

const { attributionTouch } = featureFlags

/**
 * Captures the attribution of this page load once (FE-320).
 *
 * The result waits in sessionStorage for the next identity-creating call —
 * `createGuestSession` or `signInPrivy` — which sends it along. A visit that
 * brings new tags while the tab already holds some is a "touch": it replaces
 * the buffer and, once BE-311 ships `touchAttribution` (feature flag), is
 * reported straight away for the current user or guest session.
 */
export const useCaptureAttribution = () => {
  const [touchAttribution] = useMutation(TOUCH_ATTRIBUTION)

  useEffect(() => {
    const captured = captureAttribution({
      search: window.location.search,
      href: window.location.href,
      origin: window.location.origin,
      referrer: document.referrer
    })
    if (!captured) return

    const previous = readStoredAttribution()
    storeAttribution(captured)

    if (!attributionTouch || !previous) return

    touchAttribution({ variables: { data: captured } }).catch(error =>
      console.error('touchAttribution failed', error)
    )
  }, [touchAttribution])
}
